import { fromBech32, toBech32 } from './format/convert.js';
import { Inner } from './format/inner.js';
import { Prefixes } from './format/prefix.js';
const innerName = Inner.penumbracompat1;
const prefix = Prefixes.penumbracompat1;
export const bech32CompatAddress = ({ [innerName]: bytes }) => toBech32(bytes, prefix);
export const compatAddressFromBech32 = (penumbracompat1) => ({
    [innerName]: fromBech32(penumbracompat1, prefix),
});
export { PENUMBRA_BECH32M_ADDRESS_LENGTH, PENUMBRA_BECH32M_ADDRESS_PREFIX } from './index.js';
